import React, { useState } from 'react';
import { Search, X } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const SearchModal = ({ isOpen, onClose }) => {
  const { t } = useLanguage();
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      // Navigate to products page with search term
      window.location.href = `/products?search=${encodeURIComponent(searchTerm.trim())}`;
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-gray-800 rounded-xl p-6 w-full max-w-md mx-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-white">
            {t('common.search')}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors duration-200"
          >
            <X size={24} />
          </button>
        </div>
        
        <form onSubmit={handleSearch} className="space-y-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Rechercher des bijoux..."
              className="w-full pl-10 pr-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
              autoFocus
            />
          </div>
          
          <button
            type="submit"
            className="w-full btn-primary"
            disabled={!searchTerm.trim()}
          >
            {t('common.search')}
          </button>
        </form>
        
        <div className="mt-6">
          <h3 className="text-sm font-medium text-gray-300 mb-3">
            Recherches populaires
          </h3>
          <div className="flex flex-wrap gap-2">
            {['Bagues', 'Colliers', 'Bracelets', 'Boucles d\'oreilles', 'Or', 'Argent'].map((term) => (
              <button
                key={term}
                onClick={() => {
                  setSearchTerm(term);
                  window.location.href = `/products?search=${encodeURIComponent(term)}`;
                  onClose();
                }}
                className="px-3 py-1 bg-gray-700 text-gray-300 rounded-full text-sm hover:bg-gray-600 transition-colors duration-200"
              >
                {term}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchModal; 